<template>
  <div class="wrapper">
    <!-- Header -->
    <header class="py-3">
      <h2 class="mb-0 text-white text-center">Pregnancy</h2>
    </header>

    <!-- Vaccination Buttons -->
    <div class="container py-4">
      <div class="row g-3">
        <!-- Individual Vaccine Buttons -->

        <div
          v-for="(item, index) in buttons"
          :key="index"
          class="col-6 col-sm-4 col-md-3 col-lg-3 text-center"
        >
          <router-link
            v-if="!item.disabled"
            :to="`/secondPregHome/${item.name}`"
            class="text-decoration-none"
          >
            <div
              class="action-wrapper h-100 d-flex flex-column align-items-center p-3"
            >
              <img
                :src="item.imgPath"
                :alt="`Button ${index + 1}`"
                class="img-fluid mb-2"
                style="max-height: 200px"
              />
            </div>
          </router-link>

          <!-- If the card is disabled, show a non-clickable version -->
          <div
            v-else
            class="action-wrapper disabled-card h-100 d-flex flex-column align-items-center p-3"
          >
            <img
              :src="item.imgPath"
              :alt="`Button ${index + 1}`"
              class="img-fluid mb-2"
              style="max-height: 200px"
            />
          </div>
        </div>

        <!-- Bottom Image (Large Illustration) -->
        <div class="col-12 text-center">
          <img
            src="@/assets/page4/Asset 48.png"
            alt="Bottom Image"
            class="img-fluid"
          />
        </div>
      </div>
    </div>

    <!-- Footer Banner -->
    <div class="text-center mt-4 lower-panner">
      <img
        src="@/assets/page4/lowererPanner.png"
        alt="Lower Banner"
        class="img-fluid mx-auto d-block"
      />
    </div>

    <!-- Footer Navigation -->
    <!-- <FooterNavigation
      :prevRoute="'/vaccination'"
      :nextRoute="'/secondPregHome'"
    /> -->
  </div>
</template>

<script setup>
// import FooterNavigation from "@/components/FooterNavigation.vue";
import { ref, onMounted } from "vue";

// Button data
const buttons = [
  {
    imgPath: require("@/assets/page4/Asset1.png"),
    name: "Influenza",
    route: "/secondPregHome",
  },
  {
    imgPath: require("@/assets/page4/Asset2.png"),
    name: "Pregnancy",
    route: "/secondPregHome",
     disabled: true
  },
  {
    imgPath: require("@/assets/page4/Asset3.png"),
    name: "Tetanus",
    route: "/secondPregHome",
  },
  {
    imgPath: require("@/assets/page4/Asset4.png"),
    name: "COVID-19",
    route: "/secondPregHome",
  },
  {
    imgPath: require("@/assets/page4/Asset5.png"),
    name: "Pregnancy",
    route: "/secondPregHome",
     disabled: true
  },
  {
    imgPath: require("@/assets/page4/Asset6.png"),
    name: "RSV",
    route: "/secondPregHome",
  },
  {
    imgPath: require("@/assets/page4/Asset7.png"),
    name: "HepatitisA",
    route: "/secondPregHome",
  },

  {
    imgPath: require("@/assets/page4/Asset8.png"),
    name: "Pregnancy",
    route: "/secondPregHome",
     disabled: true
  },
  {
    imgPath: require("@/assets/page4/Asset9.png"),
    name: "HepatitisB",
    route: "/secondPregHome",
  },
  
  {
    imgPath: require("@/assets/page4/asset15.png"),
    name: "VaccinesNotRecommended",
    
    route: "/secondPregHome",
  },

  {
    imgPath: require("@/assets/page4/Asset5.png"),
    name: "Pregnancy",
    route: "/secondPregHome",
     disabled: true
  },
  
  {
    imgPath: require("@/assets/page4/asset13.png"),
    name: "TravelvaccinesduringPregnancy",
    route: "/secondPregHome",
  },
];

const isMounted = ref(false);

// Animation trigger on mount
onMounted(() => {
  isMounted.value = true;
});
</script>
<style scoped>
/* Header Styling */
header {
  background-color: #2c4fa1;
}
header h2 {
  color: white;
}

/* Button Animation and Hover Effects */
.action-wrapper {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}
.action-wrapper:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

/* Slide-Up Animation */
.slide-up {
  animation: slide-up 0.6s ease-out;
}
@keyframes slide-up {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Footer Banner */
footer img {
  max-height: 100px;
}
.lower-panner {
  margin-bottom: 10rem;
}
.disabled-card {
  opacity: 0.4;
  pointer-events: none;
  filter: grayscale(100%);
  cursor: not-allowed;
}
</style>
